// React Basic and Bootstrap
import React, { useEffect } from "react"
import { Container, Row, Col } from "reactstrap"

// Gatsby Specific imports
import { useStaticQuery, graphql } from "gatsby"
import { getSrc } from "gatsby-plugin-image"

//Import Slick Slider
import Slider from "react-slick"

// Import slick css files
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

const Section = () => {
  var settings = {
    autoplay: true,
    infinite: true,
    autoplaySpeed: 1500,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    draggable: true,
    pauseOnHover: true,
  }

  const data = useStaticQuery(graphql`
    {
      markdownRemark(frontmatter: { contentKey: { eq: "academyPage" } }) {
        frontmatter {
          hero_section_of_academy_page {
            item_1 {
              title_1
              description_1
              bg_image_1 {
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
            item_2 {
              title_2
              description_2
              bg_image_2 {
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
            item_3 {
              title_3
              description_3
              bg_image_3 {
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
          }
        }
      }
    }
  `)

  const { item_1, item_2, item_3 } =
    data.markdownRemark.frontmatter.hero_section_of_academy_page

  const items2 = [
    {
      image: getSrc(item_1.bg_image_1),
      title: item_1.title_1,
      desc: item_1.description_1,
      icon: "mdi-book-open-variant",
    },
    {
      image: getSrc(item_2.bg_image_2),
      title: item_2.title_2,
      desc: item_2.description_2,
      icon: "mdi-school",
    },
    {
      image: getSrc(item_3.bg_image_3),
      title: item_3.title_3,
      desc: item_3.description_3,
      icon: "mdi-account",
    },
  ]

  useEffect(() => {
    var e1 = document.getElementsByClassName("slick-slide")
    for (var i = 0; i < 3; i++) {
      if (i === 0)
        e1[i].style.backgroundImage = `url(${getSrc(item_1.bg_image_1)})`
      if (i === 1)
        e1[i].style.backgroundImage = `url(${getSrc(item_2.bg_image_2)})`
      if (i === 2)
        e1[i].style.backgroundImage = `url(${getSrc(item_3.bg_image_3)})`
    }
  }, [item_1.bg_image_1, item_2.bg_image_2, item_3.bg_image_3])

  return (
    <>
      <section className="main-slider">
        <Slider className="slides" {...settings}>
          {items2.map((item, key) => (
            <li
              key={key}
              className="bg-home d-flex align-items-center"
              style={{
                backgroundImage: `url(${item.image})`,
              }}
            >
              <div className="bg-overlay"></div>
              <Container>
                <Row className="justify-content-center">
                  <Col xs="12" className="text-center">
                    <div className="title-heading text-white mt-4">
                      <h3 className=" title-dark fw-bold mb-3">{item.title}</h3>
                      <p className="para-desc para-dark mx-auto text-light">
                        {item.desc}
                      </p>
                    </div>
                  </Col>
                </Row>
              </Container>
            </li>
          ))}
        </Slider>
      </section>
    </>
  )
}

export default Section
